"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertySchema = exports.addressSchema = void 0;
var constants_1 = require("@hobt/constants");
var constants_2 = require("../../constants");
exports.addressSchema = {
    type: 'object',
    required: [],
    properties: {
        additionalStreetNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        municipalityName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        postalCode: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        provinceCode: {
            type: ['string', 'null'],
            enum: __spreadArrays(Object.values(constants_1.StatisticsCanadaProvinceID), [null]),
            errorMessage: 'Should equate to a valid StatisticsCanadaProvinceID Enum value or null',
        },
        streetDirection: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_2.StreetDirection), [null]),
            errorMessage: 'Should equate to a valid StreetDirection Enum value or null',
        },
        streetName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        streetNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        streetType: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_2.StreetType), [null]),
            errorMessage: 'Should equate to a valid StreetType Enum value or null',
        },
        unitNumber: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
    },
};
exports.propertySchema = {
    type: 'object',
    required: [],
    properties: {
        address: exports.addressSchema,
        bedCount: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        buildingType: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_2.BuildingType), [null]),
            errorMessage: 'Should equate to a valid BuildingType Enum value or null',
        },
        unitCount: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 100,
            errorMessage: 'Should be a string with a maximum of 100 characters or null',
        },
        completeLegalDescription: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 1000,
            errorMessage: 'Should be a string with a maximum of 1000 characters or null',
        },
    },
};
